// extracted by mini-css-extract-plugin
module.exports = {"sliderItem":"FLcl","ready":"FLcn"};